import React from 'react'
import withStyles from 'isomorphic-style-loader/withStyles';
import Skeleton from '../../../Common/Skeleton/Skeleton'
import s from './ProfileCardSkeleton.css'

function ProfileCardSkeleton() {
  return (
    <div className={s.profileCardSkeletonBox}>
      <Skeleton className={s.profileCardImgSkeleton} />
      <div className={s.profileCardInfoBoxSkeleton}>
        <Skeleton className={s.profileCardInfoTitleSkeleton} />
        <Skeleton className={s.profileCardInfoDesSkeleton} />
      </div>
    </div>
  )
}

export default withStyles(s)(ProfileCardSkeleton);
